module.exports = __webpack_public_path__ + "img/printer.e5a93b43.svg";